/**
 * @generated SignedSource<<6987eb3ea296afa647f08b3d49a5313b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type estimatedValueFurnitureTestHelpers_item$data = {
  readonly isFurniture: boolean | null;
  readonly " $fragmentType": "estimatedValueFurnitureTestHelpers_item";
};
export type estimatedValueFurnitureTestHelpers_item$key = {
  readonly " $data"?: estimatedValueFurnitureTestHelpers_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"estimatedValueFurnitureTestHelpers_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "estimatedValueFurnitureTestHelpers_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFurniture",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "dcf62a91837df76a23c0da762ebc00be";

export default node;
